import {DateFilterModel} from 'ag-grid-community';
import {FilterModel} from '../../../filter-model';
import {ISimpleFilterModelType} from 'ag-grid-community';

export function isDateFilter(
  filterMode: FilterModel<ISimpleFilterModelType>,
): filterMode is DateFilterModel {
  return filterMode.filterType === 'date';
}
